module.exports = __webpack_public_path__ + "static/media/gendigital.d42fa338.svg";